var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3652 27.4856L8.07387 31.8438C7.09591 32.3581 5.95408 31.528 6.14061 30.4395L7.72346 21.2075C7.79807 20.7759 7.65418 20.3348 7.33974 20.0284L0.632625 13.4905C-0.158798 12.7191 0.278217 11.376 1.37075 11.2175L10.64 9.87048C11.0744 9.80785 11.4487 9.53472 11.6433 9.14167L15.7882 0.742459C16.2772 -0.247486 17.6895 -0.247486 18.1772 0.742459L22.3222 9.14167C22.5167 9.53472 22.8911 9.80785 23.3254 9.87048L32.5947 11.2175C33.6872 11.376 34.1242 12.7191 33.3328 13.4905L26.6257 20.0284C26.3112 20.3348 26.1687 20.7759 26.242 21.2075L27.8248 30.4395C28.0113 31.528 26.8695 32.3581 25.8916 31.8438L17.6003 27.4856C17.2125 27.2818 16.7489 27.2818 16.3598 27.4856H16.3652Z",
    fill: "#D6A42D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionStar);
export default __webpack_public_path__ + "static/media/question-star.02427873138783d8fd5ef148cae0a555.svg";
export { ForwardRef as ReactComponent };